/// <amd-module name="VSS/Features/ReduxDirectory/Redux/UIState/DirectoryUIStateReducer" />
import { DirectoryGroupKeys } from "VSS/Features/Directory/DirectoryConstants";

import produce from "immer";
import { IDirectoryUIState } from "Contracts";
import { DirectoryActions, DirectoryActionTypes } from "../DirectoryActions";

/**
 * Reducer which handles the UI state
 */
export function directoryUIStateReducer(state: IDirectoryUIState, action: DirectoryActions): IDirectoryUIState {
    return produce(state || getDefaultState(), draft => {
        switch (action.type) {
            case DirectoryActionTypes.InitialDataLoadFailed: {
                draft.exceptionInfo = action.payload;
                break;
            }

            case DirectoryActionTypes.InitialDataLoaded: {
                draft.newDashboardDirectoryLoading = true;
                break;
            }

            case DirectoryActionTypes.BeginLoadAllData: {
                draft.isAllSectionLoading = true;
                break;
            }

            case DirectoryActionTypes.LoadAllDataSucceeded: {
                draft.isAllSectionLoading = false;
                draft.isAllSectionPopulated = true;
                break;
            }

            case DirectoryActionTypes.LoadAllDataFailed: {
                draft.isAllSectionLoading = false;
                draft.exceptionInfo = action.payload;
                break;
            }

            case DirectoryActionTypes.RowGroupCollapsedInitialized: {
                const initialMapping = { ...action.payload };
                // ignore the saved all state
                delete initialMapping[DirectoryGroupKeys.AllGroupKey];

                draft.rowGroupCollapsedMap = { ...draft.rowGroupCollapsedMap, ...initialMapping };
                break;
            }

            case DirectoryActionTypes.RowGroupToggled: {
                const { collapsed, rowGroupKey } = action.payload;
                draft.rowGroupCollapsedMap[rowGroupKey] = collapsed;
                break;
            }

            case DirectoryActionTypes.ToggleFilter: {
                draft.isFilterBarVisible = !draft.isFilterBarVisible;
                break;
            }

            case DirectoryActionTypes.NavigateToUrl: {
                draft.isNavigating = true;
                break;
            }
        }
    });
}

export function getDefaultState(): IDirectoryUIState {
    return {
        isFilterBarVisible: false,
        isNavigating: false,
        isAllSectionLoading: false,
        isAllSectionPopulated: false,
        rowGroupCollapsedMap: {
            [DirectoryGroupKeys.AllGroupKey]: true
        },
        newDashboardDirectoryLoading : false
    };
}
